import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-md focus:bg-accent focus:text-accent-foreground focus:px-4 focus:py-2 focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Zum Hauptinhalt springen
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1 pt-16 sm:pt-20 focus:outline-none">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
